import store from "../../store"
import Cookies from 'js-cookie'
import Config from './config.js'

export default class Login {
	// 判断是否登录
	static checkLogin () {
		return JSON.stringify(store.state.safeInfo) != "{}";
	}
	
	static setSafeInfo (kj, kt) {
		var _safeInfo = {
			kj,
			kt
		};
		store.commit("setSafeInfo", _safeInfo);
	}
	
	static setLoginInfo (code) {
		var _loginInfo = {
			code
		};
		store.commit("setLoginInfo", _loginInfo);
	}
	
	static setSafeInfoCache (kj, kt) {
		var _safeInfo = {
			kj,
			kt
		};
		Cookies.set('kfCloudAdmin_safeInfo', JSON.stringify(_safeInfo), {expires: Config.cookie_expires});
	}
	
	static setLoginInfoCache (code) {
		var obj = {
			code
		};
		Cookies.set('kfCloudAdmin_loginInfo', JSON.stringify(obj), {expires: Config.cookie_expires});
	}
	
	// 退出登录
	static exit () {
		Cookies.remove('kfCloudAdmin_safeInfo');
		Cookies.remove('kfCloudAdmin_loginInfo');
		store.commit("setSafeInfo", {});
		store.commit("setLoginInfo", {});
		store.commit("setAuthInfo", {});
	}
	
	// 初始化判断
	static init () {
		if (Cookies.get('kfCloudAdmin_safeInfo') && Cookies.get('kfCloudAdmin_loginInfo')) {
			store.commit("setSafeInfo", JSON.parse(Cookies.get('kfCloudAdmin_safeInfo')));
			store.commit("setLoginInfo", JSON.parse(Cookies.get('kfCloudAdmin_loginInfo')));
		} else {
			Cookies.remove('kfCloudAdmin_safeInfo');
			Cookies.remove('kfCloudAdmin_loginInfo');
		}
	}
}
 
 
 
 